import {DisplayOption} from '@/components/interfaces/ComponentOptions';
import {HTTP} from '@/services/HttpServices';
import {Event, EventSearchResults} from '@/sports-schedule/eventModels';
import {CancelToken} from 'axios';
import EventFilterData from '@/sports-schedule/filter/EventFilterModel';

const BASE_PATH = '/admin/events';

export function getStatuses(): Promise<DisplayOption[]> {
    return HTTP.get('/admin/event-statuses');
}

export function getBillboardCities(): Promise<DisplayOption[]> {
    return HTTP.get('/admin/billboard-cities');
}

export function searchEventSummaries(searchText: string, filters: EventFilterData, cancelToken: CancelToken): Promise<EventSearchResults> {
    return HTTP.post(`/admin/events/search?searchText=${searchText}`, filters, {cancelToken});
}

export function getEvent(eventId: number): Promise<Event> {
    return HTTP.get(`/admin/events/${eventId}`);
}

export function createEvent(event: Event): Promise<Event> {
    return HTTP.post(`/admin/events`, event);
}

export function updateEvent(event: Event): Promise<void> {
    return HTTP.put(`/admin/events/${event.id}`, event);
}

export function deleteEvent(id: number): Promise<void> {
    return HTTP.httpDelete(`/admin/events/${id}`);
}

export function postImportCsv(data: any): Promise<any> {
    return HTTP.post(`/admin/events/import/`, data);
}

export function postGenerateTemplate(): Promise<any> {
    return HTTP.post(`/admin/events/import/template`);
}

export function postGenerateExcelTemplate(): Promise<any> {
    return HTTP.post(`/admin/events/import/excel-template`);
}

export function postExportNielsen(filters: EventFilterData, searchText: string): Promise<any> {
    return HTTP.postExpectingBlob(`/admin/events/export/nielsen?searchText=${searchText}`, filters);
}

export function postExportRovi(filters: EventFilterData, searchText: string): Promise<Buffer> {
    return HTTP.postExpectingBlob(`/admin/events/export/rovi?searchText=${searchText}`, filters);
}

export function postExportPdf(filters: EventFilterData, searchText: string, customTitle: string): Promise<Buffer> {
    return HTTP.postExpectingBlob(`/admin/events/export/pdf?searchText=${searchText}`, {... filters, customTitle});
}

export async function getBillboardPreview(eventId: number, billboardType: string): Promise<string> {
    const data = await HTTP.get(`/admin/events/${eventId}/billboard/${billboardType}`);
    return 'data:image/jpeg;base64, '.concat(data);
}

export function sendBillboardNow(eventId: number): Promise<any> {
    return HTTP.post(`/admin/events/${eventId}/billboard-sender`);
}

export function batchDeleteEvents(eventIds: number[]): Promise<void> {
    return HTTP.post(`${BASE_PATH}/batch-delete`, { eventIds });
}